import React from 'react'
import { Input, Label } from 'reactstrap'
import './FileUploadButton.css'

const FileUploadButton = ({ maxWidth, onChange, label }) => {
    return (
        <div id='fileUpload'>
            <Label className='customFileUpload' style={{ maxWidth: maxWidth ? maxWidth : '120px' }}>
                <Input
                    type='file'
                    onChange={onChange}
                    accept="image/*, application/pdf"
                    multiple
                // onChange={(e) => handleCommonUpload(e)}
                />
                {/* Select File */}
                {label}
            </Label>
        </div>

    )
}

export default FileUploadButton
